"use client";

import { Loader } from "@solidstarters/solid-core-ui";
import React from "react";

const Loading = () => {
  return <Loader />;
};

export default Loading;
